import { action } from 'easy-peasy';

import { IActionSetEffectiveDates } from '../types';

const setEffectiveDates: IActionSetEffectiveDates = action((state, payload) => {
  state.clientTreatmentPlans.effectiveDates = payload.dates;
});

export default setEffectiveDates;
